module.exports = __webpack_public_path__ + "static/img/3.a08354ca.png";